"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var stringToDate = function (value) {
    if (typeof value === "object") {
        if (Array.isArray(value)) {
            return value.map(function (value) { return (0, exports.stringToDate)(value); });
        }
        else if (value) {
            return Object.entries(value).reduce(function (values, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (__assign(__assign({}, values), (_b = {}, _b[key] = (0, exports.stringToDate)(value), _b)));
            }, {});
        }
    }
    else if (typeof value === "string") {
        var dayjsDate = (0, dayjs_1.default)(value);
        return (dayjsDate.isValid()
            ? dayjsDate.toDate()
            : value);
    }
    return value;
};
exports.stringToDate = stringToDate;
